<footer id="footer">
  <div class="footer-top">
    <div class="container">
      <div class="d-flex align-items-center">
        <div class="logo">
          <img
            src="https://fpt.vn/assets/frontend/img/footer_logo.svg"
            alt=""
            width="auto"
            height="auto"
          />
        </div>
        <div class="list-app">
          <ul>
            <li *ngFor="let item of listSocial">
              <img src="{{ item }}" alt="" width="auto" height="auto" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="main-footer">
    <div class="container">
      <div class="row flex-column-reverse flex-md-row">
        <div class="col-lg-4 col-md-4 col-xs-12">
          <div class="col-wrapper">
            <p>
              Giấy chứng nhận ĐKKD số 0101778163 do Sở Kế hoạch Đầu tư Thành phố
              Hà Nội cấp ngày 28/07/2005
            </p>
            <p>
              Giấy phép cung cấp dịch vụ viễn thông số 255/GP-CVT do Cục Viễn
              Thông cấp ngày 07/11/2022
            </p>
            <p>
              Công ty Cổ phần Viễn thông FPT Địa chỉ trụ sở công ty: Tầng 2, tòa
              nhà FPT Cầu Giấy, số 17 Duy Tân, Phường Dịch Vọng Hậu, Quận Cầu
              Giấy, TP. Hà Nội Địa chỉ liên lạc: Tầng 9, Block A, tòa nhà FPT
              Cầu Giấy, số 10 Phạm Văn Bạch, quận Cầu Giấy, TP. Hà Nội Thư điện
              tử:
              <a href="mailto:hotrokhachhang@fpt.com">hotrokhachhang@fpt.com </a
              >Số điện thoại liên hệ:
              <a href="tel:02473002222">024 7300 2222</a> Tên người đại diện:
              Ông Hoàng Việt Anh
            </p>
            <p class="m-0">
              <img
                src="https://fpt.vn/storage/upload/images/blocks/20150827110756-dathongbao.png"
                alt=""
                width="auto"
                height="auto"
              />
            </p>
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-xs-12">
          <div class="row hide-on-mobile">
            <div class="col-lg-4 col-md-4 col-xs-12">
              <div class="footer-title">VỀ FPT TELECOM</div>
              <ul>
                <li *ngFor="let item of footerMenu1">
                  <a href="{{ item.url }}" target="_blank">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-4 col-md-4 col-xs-12">
              <div class="footer-title">Khách hàng FPT Telecom</div>
              <ul>
                <li *ngFor="let item of footerMenu2">
                  <a href="{{ item.url }}" target="_blank">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-4 col-md-4 col-xs-12">
              <div class="footer-title">Chưa là khách hàng</div>
              <ul>
                <li *ngFor="let item of footerMenu3">
                  <a href="{{ item.url }}" target="_blank">{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="list-menu">
            <div class="item">
              <a (click)="showMenu1 = !showMenu1" class="toggle-menu">
                <span>Về FPT Telecom</span
                ><img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/arrow-right-slick.png"
                  [ngClass]="showMenu1 ? 'rotate' : ''"
                  width="auto"
                  height="auto"
                  alt=""
                />
              </a>
              <ul *ngIf="showMenu1">
                <li *ngFor="let item of footerMenu1">
                  <a href="{{ item.url }}" target="_blank">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="item">
              <a (click)="showMenu2 = !showMenu2" class="toggle-menu"
                ><span> Khách hàng FPT Telecom</span
                ><img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/arrow-right-slick.png"
                  [ngClass]="showMenu2 ? 'rotate' : ''"
                  width="auto"
                  height="auto"
                  alt=""
                />
              </a>
              <ul *ngIf="showMenu2">
                <li *ngFor="let item of footerMenu2">
                  <a href="{{ item.url }}" target="_blank">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="item">
              <a (click)="showMenu3 = !showMenu3" class="toggle-menu">
                <span> Chưa là khách hàng</span>
                <img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/arrow-right-slick.png"
                  [ngClass]="showMenu3 ? 'rotate' : ''"
                  width="auto"
                  height="auto"
                  alt=""
              /></a>
              <ul *ngIf="showMenu3">
                <li *ngFor="let item of footerMenu3">
                  <a href="{{ item.url }}" target="_blank">{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-footer">
    <div class="container">
      <ngx-slick-carousel class="list-product" [config]="slideConfig">
        <div class="image" *ngFor="let product of listProduct" ngxSlickItem>
          <img src="{{ product }}" alt="" width="auto" height="auto" />
        </div>
      </ngx-slick-carousel>
      <div class="list-app">
        <ul>
          <li *ngFor="let item of listSocial">
            <img src="{{ item }}" alt="" width="auto" height="auto" />
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="copy-right">
    <div class="container">
      <div>© 2018 Bản quyền thuộc về FPT Telecom</div>
    </div>
  </div>
</footer>
